"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoQuestionWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var InfoQuestionCollapseWrapper_1 = require("./InfoQuestionCollapseWrapper");
var InfoQuestionModalWrapper_1 = require("./InfoQuestionModalWrapper");
var InfoQuestionWrapper = /** @class */ (function (_super) {
    __extends(InfoQuestionWrapper, _super);
    function InfoQuestionWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoQuestionWrapper.prototype.render = function () {
        if (this.props.hideInfoButton) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group ".concat(this.props.className || ""), children: [(0, jsx_runtime_1.jsx)("label", { children: this.props.label }), this.props.children] }));
        }
        switch (this.props.infoType) {
            case "collapse":
                return ((0, jsx_runtime_1.jsx)(InfoQuestionCollapseWrapper_1.InfoQuestionCollapseWrapper, { className: this.props.className, classNameOpened: this.props.classNameOpened, label: this.props.label, info: this.props.info, children: this.props.children }));
            case "modal":
                return ((0, jsx_runtime_1.jsx)(InfoQuestionModalWrapper_1.InfoQuestionModalWrapper, { className: this.props.className, label: this.props.label, info: this.props.info, infoTitle: this.props.infoTitle, children: this.props.children }));
            default:
                return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group ".concat(this.props.className || ""), children: [(0, jsx_runtime_1.jsx)("label", { children: this.props.label }), this.props.children] }));
        }
    };
    return InfoQuestionWrapper;
}(React.Component));
exports.InfoQuestionWrapper = InfoQuestionWrapper;
//# sourceMappingURL=InfoQuestionWrapper.js.map